import { Request } from '../../../httpClient/serverApi/requests/Request';
import { IGetItemsResult } from '../types/IGetItemsResult';
import { IGetItemsWithTokenParams } from '../types/IGetItemsWithTokenParams';
import { ISiteUser } from '../types/ISiteUser';

export interface IGetSiteUsersWithTokenParams extends IGetItemsWithTokenParams {
}

export interface IGetSiteUsersWithTokenResult extends IGetItemsResult {
  users: ISiteUser[];
}

export class GetSiteUsersWithTokenRequest extends Request<IGetSiteUsersWithTokenParams, IGetSiteUsersWithTokenResult> {
  constructor(params: IGetSiteUsersWithTokenParams = {}) {
    super('getSiteUsersWithToken', params);
  }
}